import React, { Component } from 'react';
import axios from '../../axios';
import './blue-page-1.css';
import email from '../../assets/email.png';
import apiError from '../../error';
import { PiPlayLight } from "react-icons/pi";
import { Button } from 'react-bootstrap';
import BluePageModal from '../../component/blue-page-modal/blue-page-modal';
import Loader from '../../component/loader/loader';
import swalAlert from '../../swalFunction';

export default class Actions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showBlueModal: true,
            isInstantAwareness: false,
            loading: false
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ isInstantAwareness: Object.fromEntries(new URLSearchParams(this.props.location.search)?.entries()).rId ? true : false });
        }, 3000);
    }

    redirectToInstantAwareness = async () => {
        try {
            this.setState({loading: true});
            const params = new URLSearchParams(this.props.location.search);
            let query = Object.fromEntries(params.entries());
            let response = await axios.get(`/api/lms/get-awareness-link`, {
                params: {
                    rId: query.rId
                }
            });
            this.setState({loading: false});
            let { instantAwarenessUrl } = response.data;
            window.location.href = instantAwarenessUrl;
        } catch (error) {
            this.setState({loading: false});
            if (error && error.response && error.response.status && error.response.status === 440) {
                for (let i = 0; i < error.response.data.errors.length; i++) {
                    swalAlert('Error', error.response.data.errors[i]);
                }
            } else if (error && error.response && error.response.data && error.response.data.errors) {
                for (let i = 0; i < error.response.data.errors.length; i++) {
                    swalAlert('Error', error.response.data.errors[i]);
                }
            } else if (error.response && error.response.data && error.response.data.isJoi) {
                for (let i = 0; error.response.data.details && i < error.response.data.details.length; i++) {
                    swalAlert('Error', error.response.data.details[i].message);
                }
            } else {
                console.log("The error is: ", error);
                if (navigator.onLine) {
                    swalAlert('Error', 'Something Went Wrong!');
                } else {
                    swalAlert('Error', 'We Are Offline, Please Check Your Internet Connetion !');
                }
            }
        }
    }

    startTraining = () => {
        this.setState({ showBlueModal: true });
    }

    hideBlueModal = () => {
        this.setState({ showBlueModal: false });
    }

    render() {
        return (
            <div className="blue-page1 bluePageWrap" id="bluePage-wrap">
                <h1 className="main-head">You have been Phished!</h1>
                <h4 className="sub-head">Remember these six rules to stay safe online</h4>
                <div className="row align-items-center">
                    <div className="col-md-3 left-side large-screen">
                        <div className="pointer-wrap d-flex">
                            <div className="para text-right">
                                <h6>Protect Your <br></br>Personal Info</h6>
                                <span className="line"></span>
                                <p> Be very cautious with your personal info including usernames and passwords</p>
                            </div>
                            <div className="outer-circle"><span className="num">1</span></div>
                        </div>
                        <div className="pointer-wrap d-flex">
                            <div className="para text-right">
                                <h6>Beware of <br></br>Suspicious Emails</h6>
                                <span className="line"></span>
                                <p>Be very suspicious of any emails you receive from trusted entities such as your bank or credit card</p>
                            </div>
                            <div className="outer-circle"><span className="num">2</span></div>
                        </div>
                        <div className="pointer-wrap d-flex">
                            <div className="para text-right">
                                <h6>Do Not Click <br></br>Suspicious Links</h6>
                                <span className="line"></span>
                                <p>Deceptive links that mimic legitimate URL addresses are a common tool used in phishing scams</p>
                            </div>
                            <div className="outer-circle"><span className="num">3</span></div>
                        </div>
                    </div>


                    <div className="col-md-3 left-side mini-screen">
                        <div className="pointer-wrap d-flex">
                            <div className="outer-circle"><span className="num">1</span></div>
                            <div className="para">
                                <h6>Protect Your <br></br>Personal Info</h6>
                                <span className="line"></span>
                                <p> Be very cautious with your personal info including usernames and passwords</p>
                            </div>
                        </div>
                        <div className="pointer-wrap d-flex">
                            <div className="outer-circle"><span className="num">2</span></div>
                            <div className="para">
                                <h6>Beware of <br></br>Suspicious Emails</h6>
                                <span className="line"></span>
                                <p>Be very suspicious of any emails you receive from trusted entities such as your bank or credit card</p>
                            </div>
                        </div>
                        <div className="pointer-wrap d-flex">
                            <div className="outer-circle"><span className="num">3</span></div>
                            <div className="para">
                                <h6>Do Not Click <br></br>Suspicious Links</h6>
                                <span className="line"></span>
                                <p>Deceptive links that mimic legitimate URL addresses are a common tool used in phishing scams</p>
                            </div>
                        </div>
                    </div>


                    <div className="col-md-6 text-center">
                        <div>
                            <img src={email} alt="email" className="img-fluid email-img"></img>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="pointer-wrap d-flex">
                            <div className="outer-circle"><span className="num">4</span></div>
                            <div className="para">
                                <h6>Know Common<br></br>Phishing Language</h6>
                                <span className="line"></span>
                                <p>Legitimate business will not send you email to ask for your login information or sensitive personal information </p>
                            </div>
                        </div>
                        <div className="pointer-wrap d-flex">
                            <div className="outer-circle"><span className="num">5</span></div>
                            <div className="para">
                                <h6>False Sense <br></br>Urgency</h6>
                                <span className="line"></span>
                                <p>Look out for emails that try to convey a sense or urgency, and be wary of any email that does not address you directly</p>
                            </div>
                        </div>
                        <div className="pointer-wrap d-flex">
                            <div className="outer-circle"><span className="num">6</span></div>
                            <div className="para">
                                <h6>Compromised <br></br>Accounts</h6>
                                <span className="line"></span>
                                <p> Warning that your account has been compromised, for example, are a common way to lure victims</p>
                            </div>
                        </div>
                    </div>

                </div>

                {this.state.isInstantAwareness &&
                    <>
                        <BluePageModal showModal={this.state.showBlueModal} hideModal={this.hideBlueModal} redirectToInstantAwareness={this.redirectToInstantAwareness} />

                        {!this.state.showBlueModal && (
                            <div className='startTrainingWrap'>
                                <div className='dFlex' style={{ alignItems: 'center', gap: '12px' }}>
                                    <span className='trainingText'><PiPlayLight className='playIcon' /> Click the button to begin the course</span>
                                    <Button className='btn btn-primary' onClick={this.redirectToInstantAwareness}>Start Course</Button>
                                </div>
                            </div>
                        )}
                    </>
                }
                {this.state.loading && <Loader/>}
            </div>

        );
    }
}